import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';

@Injectable({ providedIn: 'root' })

export class PaymentVoucherImportFileService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-hdrs/backoffice-ep';
  download_sample_path: string;

  //core2/tnt/dm/erp/internal-payment-voucher-import-file-hdrs

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-hdrs/backoffice-ep';
    this.download_sample_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-payment-voucher-import-file-hdrs';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, fileType: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + fileType;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  public downloadSampleCSV(apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    return this.httpClient.get(CSV_URL, this.getHttpHeaderBlob(apiVisa));
  }

}
